/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discord_Open_ProfileInputs */



/**
* | output |
* | --- |
* | "Open Discord profile" |
*
* @param {Discord_Open_ProfileInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const discord_open_profile = /** @type {((inputs?: Discord_Open_ProfileInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discord_Open_ProfileInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le profil Discord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir perfil de Discord")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Abrir perfil do Discord")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri profilo Discord")
	return /** @type {LocalizedString} */ ("Open Discord profile")
});